import {
  ConditionType,
  PaymentInOutFlowType,
  PndType,
  SettingWhtItem40XShowingType,
  TaxIncomeType,
  TaxSourceType,
  TransactionType,
  WHTCertItemType,
  WithholdingTaxPageSizeType,
  WitholdingTaxDocumentDisplayType,
} from "@/enums/enums";
import { ContactModel } from "../contact/contactModel";
import { MerchantDetail } from "../merchant/merchantModel";
import { UserInfoModel } from "../user/userModel";
import { CredentialModel, ElementDefaultModel, ElementUserApproveModel, ElementUserCreateModel } from "./documentModel";
import { SettingWitholdingTaxDocumentTemplateModel } from "./settingDocumentTemplate";

export class WitholdingTaxItemDocumentModel {
  whtItemId!: number;
  description!: string;
  taxIncomeType!: TaxIncomeType;
  preTaxAmount!: number;
  whtAmount!: number;
  whtRate!: number;
}

export class WitholdingTaxDocumentModel {
  whtId!: number;
  whtNumber!: string;
  whtDate!: Date;
  paymentFlowType!: PaymentInOutFlowType;
  pndType!: PndType;
  subTotal!: number;
  whtTotal!: number;
  description!: string;
  remark!: string;
  referenceOne!: string;
  referenceTwo!: string;
  createdDateTime!: Date;
  createdUser!: UserInfoModel;
  updatedDateTime!: Date;
  updatedUser!: UserInfoModel;
  approvedDateTime!: Date;
  approvedUser!: UserInfoModel;
  contact!: ContactModel;
  merchant!: MerchantDetail;
  tags!: Array<string>;
  witholdingTaxItemDocumentModel!: Array<WitholdingTaxItemDocumentModel>;
  pensionFundAmount!: number;
  socialSecurityAmount!: number;
  providentFundAmount!: number;
  isDeleted!: boolean;
  conditionType!: ConditionType;
}

export class WitholdingTaxDocumentDetailModel {
  data!: WitholdingTaxDocumentModel;
  version!: number;
}

export class WitholdingTaxOnlineViewModel {
  document!: WitholdingTaxDocumentDetailModel;
  template!: SettingWitholdingTaxDocumentTemplateModel;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  headerOptionType!: number;
  credential!: CredentialModel;
  paymentInOutFlowType!: PaymentInOutFlowType;
}

export class TaxIncomeTypeModel {
  active!: boolean;
  whtCertItemType!: WHTCertItemType;
  date!: string;
  incomeType!: number;
  newAmount!: number;
  whtAmount!: number;
  whtRateType!: number;
  description!: string;
}

export class TaxIncomeTypeTemplateModel {
  whtCertItem401!: TaxIncomeTypeModel;
  whtCertItem402!: TaxIncomeTypeModel;
  whtCertItem403!: TaxIncomeTypeModel;
  whtCertItem404A!: TaxIncomeTypeModel;
  whtCertItem40X1!: TaxIncomeTypeModel;
  whtCertItem40X2!: TaxIncomeTypeModel;
  whtCertItem40X3!: TaxIncomeTypeModel;
  whtCertItem40X4!: TaxIncomeTypeModel;
  whtCertItemOther!: TaxIncomeTypeModel;
  whtCertItemOther2!: TaxIncomeTypeModel;
}

export class SummaryTemplateModel {
  newAmount!: number;
  withholdingTax!: number;
  newAmountTextTh!: string;
}

export class WithholdingTaxDocumentTemplateModel {
  pageSize!: WithholdingTaxPageSizeType;
  displayType!: WitholdingTaxDocumentDisplayType;
  showDisplayType!: boolean;
  transactionType!: TransactionType;
  referenceOne!: ElementDefaultModel;
  referenceTwo!: ElementDefaultModel;
  issueDate!: string;
  paymentFlowType!: PaymentInOutFlowType;
  number!: ElementDefaultModel;
  merchant!: MerchantDetail;
  contact!: ContactModel;
  pndType!: PndType;
  taxIncomeType!: TaxIncomeTypeTemplateModel;
  summary!: SummaryTemplateModel;
  pensionFund!: number;
  socialSecurityFund!: number;
  providentFund!: number;
  userCreate!: ElementUserCreateModel;
  userApprove!: ElementUserApproveModel;
  merchantStampUrl!: ElementDefaultModel;
  isDeleted!: boolean;
  whtDate!: Date;
  conditionType!: ConditionType;
  whtItem40XShowingType!: SettingWhtItem40XShowingType;
}

export class WhtCertificateModel {
  whtCertificateId!: number;
  documentContactModel!: ContactModel;
  whtNumber!: string;
  whtDate!: Date;
  subTotal!: number;
  whtTotal!: number;
  conditionType!: ConditionType;
  sourceType!: TaxSourceType;
  sourceId!: number;
  itemList!: Array<WitholdingTaxItemDocumentModel>;
}

export class WhtCertificateItemModel {
  isTaxIncomeOnly!: boolean;
  sequenceNumber!: number;
  whtCertificateId!: number;
  documentContactModel!: ContactModel;
  whtNumber!: string;
  whtDate!: Date;
  subTotal!: number;
  whtTotal!: number;
  conditionType!: ConditionType;
  sourceType!: TaxSourceType;
  sourceId!: number;
  itemList!: Array<WitholdingTaxItemDocumentItemModel>;

  constructor() {
    this.whtCertificateId = 0;
  }
}

export class WitholdingTaxItemDocumentItemModel {
  isDescriptionOnly!: boolean;
  whtItemId!: number;
  description!: string;
  taxIncomeType!: TaxIncomeType;
  preTaxAmount!: number;
  whtAmount!: number;
  whtRate!: number;
}
